import { useState } from 'react';
import { toEnglishNumbers } from 'src/utils/numbers';

interface Props {
	validations?: (value: string) => string | boolean | undefined;
	defaultValue?: string;
	isNumeric?: boolean;
}

const useInput: any = ({
	validations,
	defaultValue,
	isNumeric,
}: Props = {}) => {
	const [value, setValue] = useState(defaultValue || '');
	const [errorMessage, setErrorMessage] = useState<any>(null);

	const handleValidation = (val?: any) => {
		if (validations) {
			const inputErrorMessage = validations(val);
			if (inputErrorMessage) {
				setErrorMessage(inputErrorMessage);
			} else {
				setErrorMessage(null);
			}
		}
	};

	return {
		value,
		setValue,
		errorMessage,
		reset: () => setValue(''),
		bind: {
			value,
			errorMessage,
			onChange: (event: any) => {
				const inputValue = (event.target as HTMLInputElement).value;
				if (isNumeric) {
					setValue(toEnglishNumbers(inputValue));
				} else {
					setValue(inputValue);
				}
				handleValidation(inputValue);
			},
			fireValidationOnBlur: () => {
				handleValidation(value);
			},
			onKeyPress: (event: any) => {
				if (isNumeric) {
					const char = String.fromCharCode(event.which);
					if (!/([0-9]|[۰-۹])/.test(char)) {
						event.preventDefault();
					}
				}
			},
		},
	};
};

export default useInput;
